import React from "react";
import "../style/ent.css";
import Servicessidebar from "../components/servicessidebar";

const ENTClinic = () => {
    const earClinic = [
        "Hearing Tests for Children and Adults",
        "Microscopic, Endoscopic and Audiological Examination",
        "Early Childhood Hearing Screening",
        "Hearing Aid Evaluations, Fittings, and Repairs",
        "Preventive Hearing Care",
        "Auditory Brain Stem Response Evaluations",
        "Hearing Restoration Surgeries such as Tympanoplasties, Mastoidectomies, Stapedectomies",
        "Advanced Cochlear Implant Surgeries",
        "Ear Reconstructive Surgery for Absent Ear"
    ];

    const sinusClinic = [
        "Endoscopic Septum Surgery",
        "Endoscopic Sinus Surgeries with Debrider, Laser",
        "Minimally Invasive Sinus Balloon Treatment",
        "Preventive Dentistry",
        "Allergy Assessment and Treatment",
        "Minimally Invasive Brain and Skull Base Surgery"
    ];

    const throatClinic = [
        "Professional Voice Assessment",
        "Microlaryngeal Surgeries (Videolaryngoscopic Examination)",
        "Advanced Laser Surgeries",
        "Speech and Language Therapy",
        "Snoring and Sleep Apnea Surgery"
    ];

    const headNeckClinic = [
        "Head and Neck Mass",
        "Enlarged or Diseased Lymph Nodes in the Neck",
        "Salivary Gland Mass",
        "Thyroid Swelling",
        "Submucosal Fibrosis (tobacco chewers)",
        "Oral Cancers"
    ];

    const Section = ({ title, items }) => (
        <div className="ent-section-block">
            <h3 className="ent-subtitle">{title}</h3>
            <ul className="ent-list">
                {items.map((item, i) => (
                    <li key={i} className="ent-item">
                        <span className="ent-icon">➤</span>
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className="ent-wrapper">
            <div className="container">
                <div className="ent-je">
                    <div className="ent-left">
                        <h2 className="ent-title">SAL ENT CLINIC</h2>

                        <p className="ent-description">
                            SAL’s vastly experienced Department of Ear, Nose, Throat, Head & Neck Surgery caters to a broad
                            spectrum of ENT treatments and services.
                        </p>

                        <Section title="SAL Ear Clinic" items={earClinic} />
                        <Section title="Sinus & Allergy Clinic" items={sinusClinic} />
                        <Section title="Throat & Voice Clinic" items={throatClinic} />
                        <Section title="Head & Neck Cancer Centre" items={headNeckClinic} />
                    </div>

                    <div className="ent-right">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ENTClinic;
